import { createApp } from 'vue';
import App from './App.vue';
import './assets/styles/tailwind.css';
import './registerServiceWorker';
createApp(App).mount('#app');
